import { Injector, Component, ViewEncapsulation, Inject, AfterViewInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DOCUMENT } from '@angular/common';

@Component({
    standalone: false,
    templateUrl: './default-brand.component.html',
    selector: 'default-brand',
    encapsulation: ViewEncapsulation.None
})
export class DefaultBrandComponent extends AppComponentBase implements AfterViewInit {

    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/ITP_Revised_log-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    isCollapsed: boolean = false;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector);
    }
    ngAfterViewInit(): void {
        this.isCollapsed = this.document.body.classList.contains('aside-minimize');
    }

    toggleLeftAside(): void {
        this.document.body.classList.toggle('aside-minimize');
        localStorage.setItem('aside-minimize-isSet', this.document.body.classList.contains('aside-minimize').toString());
        this.isCollapsed = this.document.body.classList.contains('aside-minimize');
        this.triggerAsideToggleClickEvent();
    }

    triggerAsideToggleClickEvent(): void {
        abp.event.trigger('app.kt_aside_toggler.onClick');
        abp.event.trigger('isSideBarToggle', this.document.body.classList.contains('aside-minimize'))
    }
}
